import React, { useState } from "react";
import "./EmailTicket.css";
import images from "../../../Utils/importImages";
import { CircularProgress, TextField } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import { MAIN_URL } from "../../../Configs/Urls";
import TicketFormat from "./TicketFormat";
import ReactDOM from "react-dom/client";
import toast from "react-hot-toast";

function EmailTicket({ onClose, Data }) {
  let [submitLoading, setSubmitLoading] = useState(false);

  let [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const validateEmail = () => {
    if (!email) {
      setEmailError("Email is required");
      return false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailError("Invalid email address");
        return false;
      } else {
        setEmailError("");
        return true;
      }
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(""); // Reset error while typing
  };

  const submitTheEmail = () => {
    let res = validateEmail();

    if (res == true) {
      emailTicket(email);
    }
  };

  const emailTicket = async (email) => {
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.top = "-10000px";
    container.style.left = "-10000px";
    container.style.width = "800px";
    container.style.background = "#fff";
    document.body.appendChild(container);

    const root = ReactDOM.createRoot(container);
    root.render(<TicketFormat Data={Data} nav={null} />);
    await new Promise((res) => setTimeout(res, 1000));

    const canvas = await html2canvas(container, { scale: 2, useCORS: true });
    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/png")
    );

    const formData = new FormData();
    formData.append("email", email || "princesharma.nspl@gmail.com");
    formData.append("ticket", blob, "ticket.png");
    setSubmitLoading(true);
    
    try {
        await fetch(`${MAIN_URL}bookings/email-ticket`, {
        method: "POST",
        body: formData,
      });

      toast.success("Ticket Sent To Email Successfully");
      onClose();
      setSubmitLoading(false);
    } catch (error) {
      toast.error("Please Try Again Later or Contact Support");
    }

    root.unmount();
    document.body.removeChild(container);
  };

  return (
    <div className="email-ticket-pop">
      <div className="header">
        <div className="heading proxima_semibold font18 color_black">
          Email E-Ticket
        </div>
        <img
          src={images["cross-icon-pop.svg"]}
          alt=""
          srcset=""
          onClick={() => onClose()}
        />
      </div>

      <div className="content">
        <TextField
          required
          id="outlined-email"
          label="Enter Your Email"
          variant="outlined"
          value={email}
          onChange={handleEmailChange}
          onBlur={validateEmail} // Validate on blur
          error={!!emailError}
          helperText={emailError}
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7", // Color when focused
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
        />

        <div
          className="btn proxima_semibold font16 color_light-gray-black"
          onClick={() => {
            if (submitLoading) {
              return;
            }
            submitTheEmail();
          }}
        >
          {submitLoading ? (
            <CircularProgress size={24} sx={{ color: "white" }} />
          ) : (
            "SEND"
          )}
        </div>
      </div>
    </div>
  );
}

export default EmailTicket;
